import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Account',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Manage account',
      description: 'Keep your account up-to-date and manage your settings.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Payment methods',
      description: 'Add, change, or select your preferred payment method.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Help and FAQs',
    },
    [AccountItemEnum.Logout]: {
      title: 'Log out',
    },
    [AccountItemEnum.Language]: {
      title: 'Language',
    },
  },
};
